// libs
import { Link } from 'react-router-dom';

// styles
import classes from './styles.module.css';

export default function CustomLink({ route, text, children, className="" }) {
  return (
    <Link 
      to={route} 
      className={`${classes.root} ${className}`}
    >
      {text && text}
      {children && children}
    </Link>
  )
}